import "../scss/theme-style.scss";
import Router from "./modules/Router";
import $ from "jquery";

$(() => {
  new Router();
  const hoge = "hoge";
  console.log(hoge);
});
